import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboUsuariosNoAsignadosOperario`, method: 'GET', body: null, token: token})
}